module.exports = __webpack_public_path__ + "img/jiantou.0a5bf92e.png";